let searchTimeoutId = null;

const siezeReplacements = {
  chico: "ch",
  mediano: "M",
  grande: "G",
  "extra grande": "XG",
};

const search = {
  isWaiting: false,
  input: document.getElementById("search-query"),
  sortBy: document.getElementById("sort-by"),
  hitsByProductId: new Map(),
  state: {
    page: {
      container: document.getElementById("search-results-page"),
      query: null,
      from: 0,
      size: 20,
    },
    modal: {
      container: document.getElementById("search-results"),
      query: null,
      from: 0,
      size: 5,
    },
  },
  _ctx(ctx = "page") {
    return ctx === "modal" ? "modal" : "page";
  },
  indexHits(hits = []) {
    for (const hit of hits) {
      if (!hit) continue;
      const pid = String(hit.productId ?? "");
      if (!pid) continue;
      this.hitsByProductId.set(pid, hit);
    }
  },
  buildFilters() {
    const filter = [];

    for (const f of (this.facets.list || [])) {
      if (f.field === "customFields.shasa-color") continue;

      if (f.field === "price") {
        const min = f.value?.min;
        const max = f.value?.max;

        if (min != null || max != null) {
          filter.push({
            field: "price",
            range: {
              ...(min != null ? { gte: String(min) } : {}),
              ...(max != null ? { lte: String(max) } : {}),
            },
          });
        }
        continue;
      }

      if (Array.isArray(f.value) && f.value.length > 0) {
        filter.push({
          field: f.field,
          value: f.value,
        });
      }
    }

    return filter;
  },

  formatMoneyForFacet(value) {
    const n = Number(value || 0);
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      maximumFractionDigits: 0,
    }).format(n);
  },

  initPriceSlider({ sliderEl, minInputEl, maxInputEl, minValueEl, maxValueEl, absoluteMin, absoluteMax, startMin, startMax }) {
    if (!sliderEl || typeof noUiSlider === "undefined") return;

    if (sliderEl.noUiSlider) {
      sliderEl.noUiSlider.destroy();
    }

    noUiSlider.create(sliderEl, {
      start: [startMin, startMax],
      connect: true,
      step: 1,
      range: {
        min: absoluteMin,
        max: absoluteMax,
      },
    });

    const syncText = (values) => {
      const [min, max] = values.map((v) => Math.round(Number(v)));

      if (minValueEl) minValueEl.textContent = this.formatMoneyForFacet(min);
      if (maxValueEl) maxValueEl.textContent = this.formatMoneyForFacet(max);

      if (minInputEl) minInputEl.value = min;
      if (maxInputEl) maxInputEl.value = max;
    };

    sliderEl.noUiSlider.on('update', (values) => {
      syncText(values);
    });

    sliderEl.noUiSlider.on('change', (values) => {
      const [min, max] = values.map((v) => Math.round(Number(v)));
      this.facets.setPrice(min, max);
    });

    const handleManualInput = () => {
      let min = Number(minInputEl.value);
      let max = Number(maxInputEl.value);

      if (!Number.isFinite(min)) min = absoluteMin;
      if (!Number.isFinite(max)) max = absoluteMax;

      min = Math.max(absoluteMin, Math.min(min, absoluteMax));
      max = Math.max(absoluteMin, Math.min(max, absoluteMax));

      if (min > max) {
        [min, max] = [max, min];
      }

      sliderEl.noUiSlider.set([min, max]);
      this.facets.setPrice(min, max);
    };

    if (minInputEl) minInputEl.addEventListener('change', handleManualInput);
    if (maxInputEl) maxInputEl.addEventListener('change', handleManualInput);
  },
  clear: (ctx) => {
    const k = search._ctx(ctx);
    const st = search.state[k];
    search.input.value = "";
    st.container.innerHTML = "";
  },
  set: (val) => {
    localStorage.setItem("isKeyword", true);
    search.input.value = val
    document.querySelector('.search__submit').click()
  },
  get: (ctx) => {
    // console.log('Search - Entra al get')
    const k = search._ctx(ctx);
    const st = search.state[k];
    let sort = null;
    if (k == "page") {
      switch (search.sortBy.value) {
        case "price-descending":
          sort = { field: "price", order: "desc" };
          break;
        case "price-ascending":
          sort = { field: "price", order: "asc" };
          break;
        case "created-descending":
          sort = { field: "datePublished", order: "desc" };
          break;
        default:
          sort = null;
          break;
      }
    }
    let query
    let searchObj1 = {}
    let searchObj2 = {}
    if (k === 'page') {
      query = st.query ?? (st.query = search.input.value.trim());
      const isKeyword = localStorage.getItem("isKeyword");
      const builtFilters = query != st.query ? [] : search.buildFilters();
      searchObj1 = {
        query: st.query ?? (st.query = search.input.value.trim()),
        products: {
          facets:["*"],
          filter: builtFilters,
          fields: ["name", "imageUrl", "url"],
          size: st.size,
          from: st.from,
        },
        keywords: { size: 8, fields: ["keyword", "_highlight.keyword", "_redirect"] },
      }
      if (sort != null) {
        searchObj1.products.sort = sort;
      }
      searchObj2 = {
        redirect: false,
        track: "serp",
      }
      //Para los ac-chip
      if (isKeyword) {
        searchObj2.isKeyword = true
        localStorage.removeItem("isKeyword");
      }
    }
    else {
      query = search.input.value.trim()
      searchObj1 = {
        query: search.input.value.trim(),
        products: {
          fields: ["name", "url"],
          size: st.size,
        },
        keywords: { size: 8, fields: ["keyword", "_highlight.keyword", "_redirect"] },
      }
      searchObj2 = {
        redirect: false,
        track: "autocomplete",
        // isKeyword: true,
      }
    }
    console.log(JSON.stringify(searchObj1),JSON.stringify(searchObj2))
    if (searchObj1.query.length > 1) {
      nostojs((api) => {
        // console.log('Debug')
      // console.log(query,st.query)
        if (query != st.query){ 
          st.from = 0;
          nostojs(api => { 
            api.recordSearchSubmit(query) 
          }) 
        }
        api.search(searchObj1, searchObj2)
          .then((response) => {
            // console.log('GET Search')
            // console.log(response)
            let allEmpty = true;
            for (let i = 0; i <= 4; i++) {
              const facet = search?.facets?.list?.[i];
              const values = facet?.value;
              if (Array.isArray(values) && values.length > 0) {
                allEmpty = false;
                break;
              }
            }
            if (
              k === 'page' &&
              response.products.facets?.length > 0
            ) {
              const tallaOrder = [
                "XCH",
                "CH",
                "M",
                "G",
                "XG",
                "CHM",
                "MG",
                "UNITALLA",
                "SIN TALLA",
              ];

              const normalize = (s) => (s ?? "").toString().toUpperCase().trim();

              const COLOR_REVERSE_MAP = (() => {
                const m = new Map();
                for (const [groupLabel, variants] of Object.entries(COLOR_FILTER_MAP)) {
                  for (const v of variants) {
                    const key = (v ?? "").toString().toUpperCase().trim();
                    if (!key) continue;
                    if (!m.has(key)) m.set(key, groupLabel);
                  }
                }
                return m;
              })();

              const isValueChecked = (field, rawValue) => {
                const f = search.facets.list.find((x) => x.field === field);
                if (!f) return false;
                const v = normalize(rawValue);
                return (f.value || []).includes(v);
              };

              const buildFacetItemsHtml = (customFacet) => {
                const isColorFacet = (customFacet.name || "").toString().toLowerCase() === "color";
                const field = customFacet.field;

                if (!isColorFacet) {
                  return (customFacet.data || [])
                    .slice()
                    .sort((a, b) => {
                      if (field !== "skus.customFields.talla") return 0;

                      const aIndex = tallaOrder.indexOf(normalize(a.value));
                      const bIndex = tallaOrder.indexOf(normalize(b.value));

                      if (aIndex === -1 && bIndex === -1) return 0;
                      if (aIndex === -1) return 1;
                      if (bIndex === -1) return -1;

                      return aIndex - bIndex;
                    })
                    .map((facet) => {
                      const raw = (facet?.value ?? "").toString();
                      const replacedFacet = raw.trim().replace(/[^a-zA-Z]/g, "").toLowerCase();
                      const facetName = facets.es[replacedFacet] || raw;
                      const checkedAttr = isValueChecked(field, raw) ? "checked" : "";

                      return `
                        <li class="list-menu__item facets__item" title="${raw}">
                          <label class="facets-checkbox">
                            <input type="checkbox" class="facets-checkbox__hide"
                              ${checkedAttr}
                              onchange="search.facets.set('${field}', '${raw}', this.checked)">
                            <span class="facets-checkbox__marker">
                              <svg width="12" height="10" class="icon icon-facets-checkmark" viewBox="0 0 12 10">
                                <path d="M2 4.82353L4.76923 8L10 2" stroke="currentColor" stroke-width="2"/>
                              </svg>
                            </span>
                            <span class="facets-checkbox__label">
                              ${facetName}
                            </span>
                          </label>
                        </li>
                      `;
                    })
                    .join("");
                }

                const groups = new Map();

                for (const facet of customFacet.data || []) {
                  const raw = (facet?.value ?? "").toString().trim();
                  if (!raw) continue;

                  const key = normalize(raw);
                  const groupLabel = COLOR_REVERSE_MAP.get(key);
                  if (!groupLabel) continue;

                  if (!groups.has(groupLabel)) groups.set(groupLabel, new Set());
                  groups.get(groupLabel).add(raw);
                }

                const orderedGroupLabels = Array.from(groups.keys()).sort((a, b) => a.localeCompare(b, "es"));

                return orderedGroupLabels
                  .map((label) => {
                    const rawList = Array.from(groups.get(label));
                    const title = rawList.join(", ");
                    const checkedAttr = isValueChecked(field, label) ? "checked" : "";

                    return `
                      <li class="list-menu__item facets__item" title="${title}">
                        <label class="facets-checkbox">
                          <input type="checkbox" class="facets-checkbox__hide"
                            ${checkedAttr}
                            onchange="search.facets.set('${field}', '${label}', this.checked, true)">
                          <span class="facets-checkbox__marker">
                            <svg width="12" height="10" class="icon icon-facets-checkmark" viewBox="0 0 12 10">
                              <path d="M2 4.82353L4.76923 8L10 2" stroke="currentColor" stroke-width="2"/>
                            </svg>
                          </span>
                          <span class="facets-checkbox__label">${label}</span>
                        </label>
                      </li>
                    `;
                  })
                  .join("");
              };

              search.facets.container.innerHTML = "";

              for (const customFacet of response.products.facets) {
                if (customFacet.name === "shasa-color") continue;

                const isPriceFacet = customFacet.field === "price" && customFacet.type === "stats";
                let contentHtml = "";

                if (isPriceFacet) {
                  const facetState = search.facets.list.find((f) => f.field === "price");
                  const absoluteMin =
                    customFacet?.min?.parsedValue ??
                    Math.round(Number(customFacet?.min?.source ?? 0));
                  const absoluteMax =
                    Math.round(Number(customFacet?.max ?? 0));

                  const startMin =
                    facetState?.value?.min != null ? facetState.value.min : absoluteMin;
                  const startMax =
                    facetState?.value?.max != null ? facetState.value.max : absoluteMax;

                  contentHtml = `
                    <div class="facets-price-slider"
                        data-price-slider-root
                        data-price-min="${absoluteMin}"
                        data-price-max="${absoluteMax}"
                        data-price-start-min="${startMin}"
                        data-price-start-max="${startMax}">
                      <div class="facets-price-slider__values">
                        <div class="facets-price-slider__value">
                          <span data-price-min-label>${search.formatMoneyForFacet(startMin)}</span>
                        </div>
                        <div class="facets-price-slider__value">
                          <span data-price-max-label>${search.formatMoneyForFacet(startMax)}</span>
                        </div>
                      </div>

                      <div class="facets-price-slider__control" data-price-slider></div>

                      <div class="facets-price-slider__inputs">
                        <label class="facets-price-slider__field">
                          <span>Mínimo</span>
                          <input type="number" inputmode="numeric" data-price-min-input value="${startMin}">
                        </label>

                        <label class="facets-price-slider__field">
                          <span>Máximo</span>
                          <input type="number" inputmode="numeric" data-price-max-input value="${startMax}">
                        </label>
                      </div>
                    </div>
                  `;
                } else {
                  const itemsHtml = buildFacetItemsHtml(customFacet);
                  contentHtml = `
                    <ul class="facets__list">
                      ${itemsHtml}
                    </ul>
                  `;
                }
                const FACET_LABELS = {
                  Price: "Precio",
                };

                search.facets.container.innerHTML += `
                  <details class="facets__details" data-facet-field="${customFacet.field}">
                    <summary>
                      <h4 class="facets__details-title">
                        ${FACET_LABELS[customFacet.name] || customFacet.name}
                        <span class="facets__count-badge" style="display:none;"></span>
                      </h4>
                      <svg class="icon icon-filter-two" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 1.5L6 5.5L2 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="square"/>
                      </svg>
                    </summary>
                    <fieldset class="facets-wrap parent-wrap">
                      ${contentHtml}
                    </fieldset>
                  </details>
                `;
              }

              const applyBtn = search.facets.container?.parentElement?.querySelector('button[type="button"].facets__submit');
              if (applyBtn) {
                applyBtn.className = 'button button--primary button--full-width facets-apply-btn facets__submit facets__submit--disabled';
                applyBtn.setAttribute('disabled', '');
                applyBtn.setAttribute('aria-disabled', 'true');
                applyBtn.onclick = null;
                applyBtn.addEventListener('click', search.facets.applyFilters);
              }

              const priceSliderRoots = search.facets.container.querySelectorAll('[data-price-slider-root]');
              priceSliderRoots.forEach((root) => {
                const sliderEl = root.querySelector('[data-price-slider]');
                const minInputEl = root.querySelector('[data-price-min-input]');
                const maxInputEl = root.querySelector('[data-price-max-input]');
                const minValueEl = root.querySelector('[data-price-min-label]');
                const maxValueEl = root.querySelector('[data-price-max-label]');

                const absoluteMin = Number(root.getAttribute('data-price-min'));
                const absoluteMax = Number(root.getAttribute('data-price-max'));
                const startMin = Number(root.getAttribute('data-price-start-min'));
                const startMax = Number(root.getAttribute('data-price-start-max'));

                search.initPriceSlider({
                  sliderEl,
                  minInputEl,
                  maxInputEl,
                  minValueEl,
                  maxValueEl,
                  absoluteMin,
                  absoluteMax,
                  startMin,
                  startMax,
                });
              });

              search.logSelectedFilters();
              search.updateFilterBadges();
            }
            const hits = response?.keywords?.hits?.map(h => h.keyword) || [];
            let wrap
            if (k === 'modal') {
              wrap = document.getElementById('search-autocomplete');
            }
            else {
              wrap = document.getElementById('search-page-autocomplete');
            }
            if (wrap) {

              wrap.innerHTML = '';
              hits.forEach(s => {
                const value = typeof s === 'string' ? s : (s.keyword || '');
                if (!value) return;
                if (value == search.input.value.trim()) return;

                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'ac-chip';
                btn.setAttribute('role', 'option');
                btn.textContent = value;

                btn.addEventListener('click', () => {
                  search.set(value);
                });

                wrap.appendChild(btn);
              });
            }
            if (k === 'page' && response.products.hits.length < 20) {
              document.getElementById('search-load-more').classList.add('d-none')
            }
            if (response.products.hits.length > 0) {
              search.indexHits(response.products.hits);
              if (st.from == 0) {
                // console.log('DEBUG FROM 0')
                // console.log(st)
                st.container.innerHTML = "";
              }
              for (const hit of response.products.hits) {
                const container = document.createElement("div");
                //// nsc = nosto search card
                const id = `card-${hit.productId}`;
                container.id = id;
                st.container.appendChild(container);
                new Card(hit.productId, id, "nostosearch");
              }
              if (k === 'modal' && window.innerWidth <= 600) {
                const existingButton = document.querySelector('.search-view-all-mobile');
                if (existingButton) {
                  existingButton.remove();
                }
                const searchQuery = encodeURIComponent(search.input.value.trim());
                const buttonWrapper = document.createElement('div');
                buttonWrapper.className = 'search-view-all-mobile';
                buttonWrapper.innerHTML = `
                  <a href="/search?q=${searchQuery}" class="search-view-all-mobile__button">
                    Ver todo
                  </a>
                `;
                setTimeout(() => {
                  st.container.appendChild(buttonWrapper);
                }, 500);
              }
            } else if (st.from == 0) {
              st.container.innerHTML = "<h2>Sin resultados</h2>";
            }
            st.query = response.query;
          });
      });
    }
  },
  facets: {
      container: document.querySelector(".facets__details__wrapper"),
      list: [
      {
        field: "skus.customFields.talla",
        value: [],
      },
      {
        field: "customFields.shasa-color",
        value: [],
      },
      {
        field: "customFields.custom-fits",
        value: [],
      },
      {
        field: "customFields.custom-product_group_code",
        value: [],
      },
      {
        field: "customFields.custom-pg_filtro",
        value: [],
      },
      {
        field: "customFields.custom-material",
        value: [],
      },
      {
        field: "customFields.custom-color",
        value: [],
      },
      {
        field: "price",
        value: {
          min: null,
          max: null,
        },
      },
    ],
    set: (name, value, checked, isColor) => {
      const facet = name.split(".").at(-1);
      const position = search.facets.list.findIndex((f) => f.field.includes(facet));
      if (position === -1) return;

      const field = search.facets.list[position].field;
      const valueUppercase = (value ?? "").toString().trim();
      const valueUppercaseNorm = valueUppercase.toUpperCase().trim();

      const expandedValues = isColor
        ? (COLOR_FILTER_MAP[valueUppercase] || COLOR_FILTER_MAP[valueUppercaseNorm] || [valueUppercase])
            .map((v) => (v ?? "").toString().toUpperCase().trim())
            .filter(Boolean)
        : [valueUppercaseNorm];

      if (checked) {
        const current = new Set(search.facets.list[position].value || []);
        expandedValues.forEach((v) => current.add(v));
        search.facets.list[position].value = Array.from(current);
      } else {
        const toRemove = new Set(expandedValues);
        search.facets.list[position].value = (search.facets.list[position].value || []).filter(
          (v) => !toRemove.has(v)
        );
      }

      search.logSelectedFilters();
      search.updateFilterBadges();
    },
    _getPriceFacet: () => {
      return search.facets.list.find((f) => f.field === "price");
    },

    setPrice: (min, max) => {
      const facet = search.facets._getPriceFacet();
      if (!facet) return;

      facet.value = {
        min: min != null && min !== "" ? Number(min) : null,
        max: max != null && max !== "" ? Number(max) : null,
      };

      search.logSelectedFilters();
      search.updateFilterBadges();
    },
    applyFilters: (e) => {
      const ctx = 'page';
      const st = search.state.page;

      st.from = 0;
      //st.query = search.input.value.trim();
      st.container.innerHTML = "";

      search.get(ctx);
    },
  },
  logSelectedFilters: () => {
    const selectedFilters = {};
    let hasFilters = false;

    search.facets.list.forEach((facet) => {
      const isArrayFacet = Array.isArray(facet.value) && facet.value.length > 0;
      const isPriceFacet =
        facet.field === "price" &&
        facet.value &&
        (facet.value.min != null || facet.value.max != null);

      if (isArrayFacet || isPriceFacet) {
        selectedFilters[facet.field] = facet.value;
        hasFilters = true;
      }
    });

    console.info('Filtros seleccionados:', selectedFilters);

    const applyBtn = search.facets.container?.parentElement?.querySelector('button[type="button"].facets__submit');
    if (applyBtn) {
      if (hasFilters) {
        applyBtn.classList.remove('facets__submit--disabled');
        applyBtn.removeAttribute('disabled');
        applyBtn.setAttribute('aria-disabled', 'false');
      } else {
        applyBtn.classList.add('facets__submit--disabled');
        applyBtn.setAttribute('disabled', '');
        applyBtn.setAttribute('aria-disabled', 'true');
      }
    }
  },
  updateFilterBadges: () => {
    const container = search.facets.container;
    if (!container) return;

    const details = container.querySelectorAll('.facets__details');

    details.forEach((detail) => {
      const checkboxes = detail.querySelectorAll('input[type="checkbox"]:checked');
      let badge = detail.querySelector('.facets__count-badge');

      const field = detail.getAttribute('data-facet-field');
      const priceFacet = search.facets.list.find((f) => f.field === "price");
      const hasPriceSelected =
        field === "price" &&
        priceFacet &&
        (priceFacet.value?.min != null || priceFacet.value?.max != null);

      const count = hasPriceSelected ? 1 : checkboxes.length;

      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'facets__count-badge';
          const title = detail.querySelector('.facets__details-title');
          if (title) title.appendChild(badge);
        }
        badge.textContent = count;
        badge.style.display = 'inline-block';
      } else {
        if (badge) {
          badge.textContent = '';
          badge.style.display = 'none';
        }
      }
    });
  },
  open: (id, url) => {
    nostojs((api) => {
      api.recordSearchClick("serp", { productId: id, url: url });
    });
    location.href = url+"?fromnostosearch=true";
  },
  loadMore: (ctx) => {
    if (!search.isWaiting) {
      const k = search._ctx(ctx);
      const st = search.state[k];
      // console.log('DEbug')
      // console.log(st)
      search.isWaiting = true;
      // console.log(st.from)
      // console.log(st.size)
      st.from += st.size;
      // console.log(st.from)
      search.get(ctx);
      setTimeout(() => {
        search.isWaiting = false;
      }, 1500);
    }
  },
  sort: (ctx) => {
    const k = search._ctx(ctx);
    const st = search.state[k];
    st.from = 0;
    search.get(ctx);
  },
};


const url = new URL(window.location.href);
if (url.pathname.includes("search")) {
  const ctx = 'modal'
  const urlQuery = url.searchParams.get("q");
  if (urlQuery) search.get(ctx);
  search.input.addEventListener("input", (event) => {
    clearTimeout(searchTimeoutId);
    searchTimeoutId = setTimeout(() => {
      search.get(ctx);
    }, 1000);
  });
  window.addEventListener("scroll", () => {
    const ctx = 'page'
    const k = search._ctx(ctx);
    const st = search.state[k];
    const rect = st.container.getBoundingClientRect();
    if (rect.bottom <= window.innerHeight) {}
  });
}
else {
  const ctx = 'modal'
  search.input.addEventListener("input", () => {
    // console.log('Search de home')
    clearTimeout(searchTimeoutId);
    searchTimeoutId = setTimeout(() => {
      search.get(ctx)
    }, 800);
  });
}

if (url.searchParams.get("source") === "serp") {
  setTimeout(() => {
    const url = new URL(window.location.href);
    const id = url.searchParams.get("product");
    const handle = url.origin + url.pathname;
    nostojs((api) => {
      api.recordSearchClick("serp", {
        productId: id,
        url: handle
      });
    });
    url.searchParams.delete('source');
    url.searchParams.delete('product');
    window.history.replaceState({}, '', url);
  }, 1000);
}
window.recordClick = (record, id) => {
  let hit
  if (record == 'category') {
    hit = category.hitsByProductId.get(id)
  }
  if (record == 'serp') {
    hit = search.hitsByProductId.get(id)
  }
  nostojs((api) => {
    api.recordSearchClick(record, hit);
  });
}